/**
 * Writing Assistant Settings page for administrators.
 *
 * Provides UI for managing system prompts used in text enhancement.
 */
import { SystemPromptConfig } from "../../components/admin/SystemPromptConfig";

export function WritingAssistantSettingsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-brand-text">
            Writing Assistant Settings
          </h1>
          <p className="mt-1 text-sm text-brand-muted">
            Configure system prompts for the AI-powered text enhancement feature
          </p>
        </div>
      </div>

      <SystemPromptConfig showInactive={true} />
    </div>
  );
}

export default WritingAssistantSettingsPage;
